/**
 * 根据登录后下发的菜单树判断是否有目标页面权限。
 * 详情/子路径常见不进菜单，按「菜单 path 前缀」匹配（如有 /exam/affair 则可进 /exam/affair/create）。
 */

function normalizePath(path) {
  if (!path) return '';
  let p = String(path).trim();
  if (!p) return '';
  if (!p.startsWith('/')) p = `/${p}`;
  if (p.length > 1 && p.endsWith('/')) p = p.slice(0, -1);
  return p;
}

export function collectMenuPaths(menus, out = []) {
  for (const menu of menus || []) {
    if (!menu) continue;
    if (menu.path) {
      out.push(normalizePath(menu.path));
    }
    if (menu.children && menu.children.length) {
      collectMenuPaths(menu.children, out);
    }
  }
  return out;
}

/**
 * @param {Array} menus 用户菜单树
 * @param {string} targetPath 目标路由 path（含或不含前置 /）
 * @returns {boolean}
 */
export function hasMenuPathAccess(menus, targetPath) {
  const target = normalizePath(targetPath);
  if (!target) return false;
  // 个人页常不挂菜单
  if (target === '/profile' || target === '/todo' || target === '/dashboard') {
    return true;
  }
  const paths = collectMenuPaths(menus);
  if (!paths.length) return false;
  const allowed = paths.some((menuPath) => {
    if (!menuPath) return false;
    if (target === menuPath) return true;
    // 菜单挂父级列表，子路由/详情视为有权
    if (target.startsWith(`${menuPath}/`)) return true;
    // 指引配置了父 path，菜单实际挂在 .../list 等子 path
    if (menuPath.startsWith(`${target}/`)) return true;
    return false;
  });
  if (allowed) return true;
  // 错题模块：有「错题入库/错题题库」等同级菜单时，允许访问「学生错题本」
  if (target === '/resource/error-bank/student') {
    const errorBankPrefix = '/resource/error-bank';
    return paths.some((p) => p === errorBankPrefix || (p && p.startsWith(`${errorBankPrefix}/`)));
  }
  return false;
}

/**
 * 解析 vue-router location，得到用于权限判断的 path。
 * @param {import('vue-router').default} router
 * @param {string|object} to
 * @returns {{ path: string, href: string } | null}
 */
export function resolveRouteLocation(router, to) {
  if (!router || to == null || to === '') return null;
  try {
    const resolved = router.resolve(to);
    if (!resolved || !resolved.route) return null;
    const path = normalizePath(resolved.route.path);
    return {
      path,
      href: resolved.href || path
    };
  } catch (e) {
    return null;
  }
}

/**
 * 在菜单树中查找路径对应的菜单名称（精确或最长前缀）。
 */
export function findMenuNameByPath(menus, targetPath) {
  const target = normalizePath(targetPath);
  let best = '';
  let bestLen = -1;
  const walk = (nodes) => {
    for (const menu of nodes || []) {
      if (!menu) continue;
      const p = normalizePath(menu.path);
      if (p && (target === p || target.startsWith(`${p}/`)) && p.length > bestLen) {
        best = menu.name || '';
        bestLen = p.length;
      }
      if (menu.children && menu.children.length) walk(menu.children);
    }
  };
  walk(menus);
  return best;
}
